import React from 'react'
import {Card, CardHeader, Table,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import reportApiService from "../../api/report-api-service";
import Badge from "reactstrap/es/Badge";
import FeedbackItem from "../Lists/FeedbackItem";
import FeedbackItemRow from "../Lists/FeedbackItemRow";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

export default class FeedbackView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            feedbacks: [],
            yclasses: [],
            students: []
        };
    }

    goToClass = this.goToClass.bind(this);

    componentDidMount() {
        this.getData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    render() {
        this.localize();

        if (this.state.goToClassId) {
            return <Redirect from="*" to={{
                pathname: "/admin/class_overview",
                state: {yclassId: this.state.goToClassId}
            }}/>
        }

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <div className="modal-body text-gray">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <Row className="align-items-center">
                                <div className="col">
                                    <h3 className="mb-0">{commonStrings.feedback}
                                        <Badge
                                            className="ml-1"
                                            color="success">{this.state.feedbacks.length}</Badge>
                                    </h3>
                                </div>
                            </Row>

                            <small><span className="mb-4">{commonStrings.feedback_expl}</span></small>
                        </CardHeader>
                        {this.state.feedbacks && this.state.feedbacks.length > 0 &&
                        (this.state.feedbacks.map((item, index) =>
                                <FeedbackItemRow
                                    goToClass={this.goToClass}
                                    key={item.id}
                                    item={item}
                                    size="large"
                                />))
                        }
                    </Card>
                </div>
            </LoadingOverlay>
        )
    }

    goToClass(e, item) {
        e.preventDefault();
        this.setState({goToClassId: item.yclass_id})
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportName() {
        return resourceStrings.cabinet.cashier
    }

    getData() {
        this.setState({isLoading: true});

        reportApiService.getFeedbacks()
            .then(res => {
                if (res.feedbacks) {
                    let feedbacks = res.feedbacks;
                    let results = [];
                    feedbacks.forEach((f) => {
                        results.push(this.updateItem(f, res.yclasses, res.students));
                    })

                    this.setState({feedbacks: results, isLoading: false})
                }
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    updateItem(item, yclasses, students) {
        if (item && item.student_id && !item.anonymous) {
            if (students) {

                let client = students.find((s) => {
                    return s.id == item.student_id
                })
                if (client) {
                    item.client_name = client.name
                    item.client_photo = client.photo
                }
            }
        }

        if (item && item.yclass_id && yclasses) {
            let yclass = yclasses.find((y) => {
                return y.id == item.yclass_id
            })
            if (yclass) {
                item.yclass = yclass
            }
        }

        return item
    }
}

